import React, {FC} from 'react';
import styled from 'styled-components';

import {fontSizes} from '../../../../../../libs/shared/ui/src/styles/fontStyles';
import {ellipsis} from '../../../../../../libs/shared/ui/src/styles/mixins';

/*
 * Style.
 */

const StyledCategoryDiv = styled.div`
  grid-area: category;

  color: ${(p) => p.theme.greys.shade70};
  font-size: ${fontSizes.verySmall};

  ${ellipsis()};
`;

/*
 * Component.
 */

export const FrameCardCategory: FC = ({children}) => <StyledCategoryDiv>{children}</StyledCategoryDiv>;
